"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tramonti": {
    "df02aa98": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "skipSearch": false
    }],
    "capitignano": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e862d4c": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "skipSearch": false
    }],
    "cesarano": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae8dd847": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "skipSearch": false
    }],
    "gete": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f4d03961": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "skipSearch": false
    }],
    "paterno-sant-arcangelo": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d42d1849": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "skipSearch": false
    }],
    "paterno-sant-elia": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0a520c4": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "skipSearch": false
    }],
    "ponte": [{
      "hkey": "ad2c9eb9",
      "slug": "tramonti",
      "name": "Tramonti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;